import { useStore } from '@project/components/hooks';
import { observer } from 'mobx-react';
import { Button, Form, Input, Typography } from 'antd';
import { useNavigate } from 'react-router';
import { PATH } from '@project/routes/constants/paths';
import HomeFilled from '@ant-design/icons/lib/icons/HomeFilled';
import '@assets/scss/home.scss';
import './style.scss';
import { useCallback, useEffect, useState } from 'react';
import { services } from '../../../API';

export const AdminForm = observer(() => {
  const rootStore = useStore();
  const navigate = useNavigate();
  const { user } = rootStore;
  const { auth } = services;
  const [error, setError] = useState<string>();
  const [isLoading, setIsLoading] = useState(false);

  const validation = [
    { required: true, message: 'Поле не должно быть пустым!' },
  ];

  const goToMap = useCallback(() => {
    navigate(PATH.MAP);
  }, []);

  const logIn = async ({
    username,
    password,
  }: {
    username: string;
    password: string;
  }) => {
    setIsLoading(true);
    setError(undefined);

    try {
      await auth.loginByUsername(username, password);
    } catch (e) {
      if (e instanceof Error) {
        setError(e.message);
      } else {
        setError('Ошибка авторизации');
      }
    }

    // TODO: Can't perform a React state update on an unmounted component. This is a no-op, but it indicates a memory leak in
    setIsLoading(false);
  };

  useEffect(() => {
    services.auth.subscribeOnLogin(goToMap);

    return () => {
      services.auth.unsubscribeOnLogin(goToMap);
    };
  }, []);

  const resultError =
    error || (user.value.status === 'error' ? user.value.error : undefined);

  return (
    <Form className="admin-form" onFinish={logIn}>
      <Button
        shape="round"
        type="primary"
        className="admin-form__to-home-container"
        onClick={() => navigate(PATH.HOME)}
      >
        <HomeFilled className="admin-form__to-home-container__icon" />
      </Button>

      <Typography.Title level={2}>Вход</Typography.Title>

      <Typography.Text className="admin-form__secondary">
        Добро пожаловать!
      </Typography.Text>
      <Typography.Text className="admin-form__secondary">
        Пожалуйста, введите свои данные ниже, чтобы войти в систему.
      </Typography.Text>

      <div style={{ width: '100%', marginTop: 42 }}>
        <Form.Item
          name="username"
          rules={validation}
          className="admin-form__filled"
        >
          <Input
            placeholder="Логин"
            autoComplete="username"
            className="admin-form__filled"
          />
        </Form.Item>

        <Form.Item
          name="password"
          rules={validation}
          className="admin-form__filled"
        >
          <Input.Password
            placeholder="Пароль"
            autoComplete="current-password"
            className="admin-form__filled"
          />
        </Form.Item>

        {resultError && (
          <Typography.Paragraph type="danger" className="admin-form__secondary">
            {resultError}
          </Typography.Paragraph>
        )}

        <Button
          loading={isLoading}
          type="primary"
          className="admin-form__filled"
          htmlType="submit"
          style={{ marginTop: 16 }}
        >
          Войти
        </Button>
      </div>
    </Form>
  );
});
